import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b5bacd56&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=b5bacd56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bacd56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5bacd56')) {
      api.createRecord('b5bacd56', component.options)
    } else {
      api.reload('b5bacd56', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b5bacd56&scoped=true&", function () {
      api.rerender('b5bacd56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uploadImagetow/index.vue"
export default component.exports